import type { FC } from "react"

import { ProductStatusCell } from "@/components/table/ProductStatusCell"
import type { Product } from "@/graphql/codegen/graphql"
import { ProductVersionChip } from "@/screens/Products/components/ProductVersionChip"

interface InventoryProductIdCellProps {
  product: Product
}

export const InventoryProductIdCell: FC<InventoryProductIdCellProps> = ({ product }) => {
  const currentVersion = (product.versions ?? []).find((version) => version.id === product.versionId)

  return (
    <div className='flex flex-col items-start gap-2'>
      <ProductStatusCell product={product} />
      {currentVersion && <ProductVersionChip version={currentVersion} />}
    </div>
  )
}
